import Statistic from "./Statistic";
import request from "../../../request";

export default function PAR() {

   return <Statistic
      title="Portfolio at Risk"
      variant="cards"
      fetchData={async (from, to) => {

         const res = await request.get('/api/general/reports/par', { params: { from, to } });

         const cards = Object.entries(res.data).map(([key, number]) => ({
            title: `${key.toUpperCase()} (%)`,
            number: number.toFixed(1),
         }));

         return [ { cards }]
      }}
   />
}